import { t } from '@lingui/macro'

import { ErrorLayout } from '@/modules/shared/components/error-layout/ErrorLayout'

export function IntramurosGeneralError() {
  return (
    <ErrorLayout
      title={t({
        id: 'errors.intramuros-general.title',
        message: 'Er ging iets mis...',
      })}
      message={t({
        id: 'errors.intramuros-general.body',
        message: 'Neem contact op met de dienst applicatiebeheer om dit probleem te verhelpen.',
      })}
      imgSrc='/img/svg/timeline-error.svg'
    />
  )
}
